export const documentation = {
  junior: [
    { name: 'Fullstack Development Standards', url: '/docs/fullstack-standards', type: 'standards' },
    { name: 'Frontend-Backend Integration Guide', url: '/docs/frontend-backend-integration', type: 'integration' },
    { name: 'Database Design Guidelines', url: '/docs/database-design', type: 'database' },
    { name: 'API Development Best Practices', url: '/docs/api-best-practices', type: 'api' },
    { name: 'Testing Strategy for Fullstack Apps', url: '/docs/fullstack-testing', type: 'testing' }
  ],
  mid: [
    { name: 'System Architecture Patterns', url: '/docs/architecture-patterns', type: 'architecture' },
    { name: 'Performance Optimization Guide', url: '/docs/performance-optimization', type: 'performance' },
    { name: 'Security Implementation Checklist', url: '/docs/security-checklist', type: 'security' },
    { name: 'Deployment and CI/CD Pipeline', url: '/docs/deployment-pipeline', type: 'deployment' },
    { name: 'Monitoring and Logging Strategy', url: '/docs/monitoring-logging', type: 'operations' }
  ],
  senior: [
    { name: 'Technical Leadership Guidelines', url: '/docs/tech-leadership', type: 'leadership' },
    { name: 'Scalability Planning Framework', url: '/docs/scalability-planning', type: 'architecture' },
    { name: 'Technology Decision Matrix', url: '/docs/technology-decisions', type: 'strategy' },
    { name: 'Cross-team Collaboration Guide', url: '/docs/cross-team-collaboration', type: 'collaboration' },
    { name: 'Incident Response Procedures', url: '/docs/incident-response', type: 'operations' }
  ]
};
